import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import PropTypes from 'prop-types'

import Form from '../../../../../../components/Form'
import SroiFormContent from '../../components/SroiFormContent'

import useManageDrawer from '../../../../../../hooks/formHooks/useManageDrawer'
import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { transformValuesToBE } from './formatters'

import {
  sroiReportPayloadSelector,
  updateSroiReportPayloadErrorSelector,
  updateSroiReportPayloadIsLoadingSelector,
  updateSroiReportPayloadWasUpdatedSelector
} from '../../../../../../modules/selectors/socialReturnOnInvestment'
import {
  clearUpdateSroiReportPayload,
  updateSroiReportPayload
} from '../../../../../../modules/actions/socialReturnOnInvestment'

import { getInitialValues } from './fields'
import { SROI_REPORT_PAYLOAD_EDIT } from '../../../../../../constants/forms'
import { validationSchema } from './validation'

const SroiReportPayloadEditForm = ({ fetchSroiReportHandler }) => {
  const dispatch = useDispatch()
  const { selectedEditItemId } = useManageDrawer({ formName: SROI_REPORT_PAYLOAD_EDIT })

  const sroiReportPayload = useSelector(sroiReportPayloadSelector)
  const sroiReportPayloadWasUpdated = useSelector(updateSroiReportPayloadWasUpdatedSelector)

  const onSubmit = useCallback(
    values => {
      const transformedValues = transformValuesToBE(sroiReportPayload, values)
      dispatch(updateSroiReportPayload(selectedEditItemId, transformedValues))
    },
    [dispatch, selectedEditItemId, sroiReportPayload]
  )

  const initialValues = useMemo(() => {
    return getInitialValues(sroiReportPayload)
  }, [sroiReportPayload])

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
    enableReinitialize: true
  })

  const purifiedFormik = usePurifiedFormik(formik)

  const clearEditSroiReportHandler = useCallback(() => {
    dispatch(clearUpdateSroiReportPayload())
  }, [dispatch])

  return (
    <Form
      formik={formik}
      formName={SROI_REPORT_PAYLOAD_EDIT}
      successSubmit={sroiReportPayloadWasUpdated}
      errorSelector={updateSroiReportPayloadErrorSelector}
      isLoadingSelector={updateSroiReportPayloadIsLoadingSelector}
      clearHandler={clearEditSroiReportHandler}
      // re-fetch the report on success to reflect the changes
      onSuccessSubmit={fetchSroiReportHandler}
    >
      <SroiFormContent formik={purifiedFormik} />
    </Form>
  )
}

SroiReportPayloadEditForm.propTypes = {
  fetchSroiReportHandler: PropTypes.func.isRequired
}

export default SroiReportPayloadEditForm
